'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, r) {
    if (null == t) return {};
    var e, o, n = _object_without_properties_loose(t, r);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(t);
        for(o = 0; o < s.length; o++)e = s[o], !(r.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(t, e) && (n[e] = t[e]);
    }
    return n;
}
function _object_without_properties_loose(t, r) {
    if (null == t) return {};
    var e, o, n = {}, s = Object.keys(t);
    for(o = 0; o < s.length; o++)e = s[o], r.indexOf(e) >= 0 || (n[e] = t[e]);
    return n;
}
t.oneOf([
    'standard',
    'alert'
]);
const Count = renderWithRef('Count', null, (r, o)=>{
    var { children: n, skin: s = 'standard' } = r, p = _object_without_properties(r, [
        "children",
        "skin"
    ]);
    let a = new Set([
        'swan-count'
    ]);
    return 'standard' != s && a.add(`swan-count-skin-${s}`), jsx(RenderComp, {
        root: "span",
        classNames: a,
        forwardedRef: o,
        props: p,
        children: n
    });
});

export { Count };
